import { authenticationService } from "@/_services";
import { router } from "@/plugins/router";

export function handleResponse(response) {
  return response.text().then(text => {
    const data = text && JSON.parse(text);
    if (!response.ok) {
      if ([401, 403].indexOf(response.status) !== -1) {
        // auto logout if 401 Unauthorized or 403 Forbidden response returned from api
        authenticationService.logout();
        //location.reload(true);
        //router.push({ name: "login", params: { isExpired: true } })
        window.location.href = "/login";
      }

      const error = (data && data.message) || response.statusText;
      return Promise.reject(error);
    }

    return data;
  });
}
